module.exports = __webpack_public_path__ + "img/Middle-Bevel-Attachment-25.ff64792e.png";